import axios from '@/services/api'

/**
 * @param {number} thread_id
 * @param {string} reply_text
 * @param {number} parent_id
 * @returns {Promise<Object>}
 */
export const addComment = ({ thread_id, reply_text, parent_id }) => {
	const url = 'api/thread-replies'
	return axios.post(url, {
		thread_id,
		reply_text,
		parent_id
	})
}

/**
 * @param {number} commentId
 * @returns {Promise<Object>}
 */
export const likeComment = (commentId) => {
	const url = 'api/thread-replies-upvote'
	return axios.post(url, {thread_reply_id: commentId})
}

/**
 * @param {number} commentId
 * @returns {Promise<Object>}
 */
export const dislikeComment = (commentId) => {
	const url = `api/thread-replies-upvote/${commentId}`
	return axios.delete(url)
}

/**
 * @param {number} eventId
 * @param {string} data
 *
 * @returns {Promise<Object>}
 */
export const addEventComment = ({ eventId, data }) => {
	const url = 'api/comments/event'
	return axios.post(url, { id: eventId, review: data })
}

/**
 * @param {number} commentId
 * @param {string} commentData
 *
 * @returns {Promise<Object>}
 */
export const updateComment = ({ commentId, commentData }) => {
	const url = `api/comments/${commentId}`
	return axios.put(url, { review: commentData })
}

/**
 * @param {number} commentId
 *
 * @returns {Promise<Object>}
 */
export const deleteComment = (commentId) => {
	const url = `api/thread-replies/${commentId}`
	return axios.delete(url)
}

/**
 * @param {number} commentId parent comment ID
 * @param {number} postId
 * @param {string} data
 *
 * @returns {Promise<Object>}
 */
export const replyComment = ({ commentId, postId, data }) => {
	const url = `api/comments/${commentId}/reply`
	return axios.post(url, { id: postId, review: data })
}
